import { TopNavigation } from '@taxbit-private/cosmic'
import { useNavigate } from 'react-router-dom'

import { BasePath } from 'routes/paths'

import useFeatureFlags from 'hooks/feature-flags/useFeatureFlags'
import useIsZeusAdminOrg from 'hooks/utils/useIsZeusAdminOrg'
import DataStatus from 'layouts/accounting-menu/DataStatus'
import GlobalEditPopover from 'layouts/accounting-menu/GlobalSyncPopover'

import { useDynamicLabels } from './useDynamicLabels'
import AccountMenu from '../accounting-menu/AccountMenu'

const TopNavigationBar = () => {
  const navigate = useNavigate()
  const { enableDataVisibilityUi } = useFeatureFlags()
  const isZeusAdminOrg = useIsZeusAdminOrg()

  const { appTitle } = useDynamicLabels()

  const syncElement = enableDataVisibilityUi ? (
    <DataStatus key="data-status" />
  ) : (
    <GlobalEditPopover key="global-edits-popup" />
  )

  // The Zeus admin org runs no nightly DAG, so it has no data status to show or poll.
  // A single element, not a one-item array: TopNavigation draws its divider for any array.
  const utilityElements = isZeusAdminOrg ? (
    <AccountMenu key="account-menu" />
  ) : (
    [<AccountMenu key="account-menu" />, syncElement]
  )

  return (
    <TopNavigation
      appTitle={appTitle}
      onLogoClick={() => navigate(BasePath.Dashboard)}
      trackingId="accounting-top-nav-bar"
      utilityElements={utilityElements}
    />
  )
}

export default TopNavigationBar
